export default __webpack_public_path__ + "static/media/idea-resourcing-logo.8871d8d7.png";